import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EmptyState from './EmptyState';
import { getPodcastData } from '../../actions';
import Podcast from '../Podcast/Podcast';
import { minImageWidth, spacing } from '../../lib/theme';
import { bookImage, singular } from '../../lib/utils';
import AppCustomLink from './AppCustomLink';

class InsightCards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            books: [],
            collectionIdsSorted: [],
            collectionIdsSortedMap: {},
        }
    }
    componentDidMount() {
        const { insights } = this.props;
        this.getBooks(insights);
    }
    componentDidUpdate(prevProps) {
        const { insights } = this.props;
        console.dir(this.props);
        // if (this.props && prevProps && (typeof userDetails !== 'undefined' && userDetails !== prevProps.userDetails)) {
        //     this.setPageData(this.props.userDetails);
        // }
        if (prevProps.insights && insights &&
            prevProps.insights !== insights) {
            console.log('insights change');
            this.getBooks(insights);
        }
    }

    getBooks(insightsMap) {
        let collectionIdsMap = {};
        const collectionIdsSortedMapLoc = {};
        // insightsMap.forEach((value, key) => {
        Object.values(insightsMap).forEach(value => {
            const collectionId = value['collectionId'];
            const time = value['time'];
            if (collectionIdsMap[collectionId] === undefined || collectionIdsMap[collectionId] < time) {
                collectionIdsMap[collectionId] = time;
                collectionIdsSortedMapLoc[collectionId] = (collectionIdsSortedMapLoc[collectionId] || 0) + 1;
            }
        });

        const collectionIdsSortedMap = collectionIdsSortedMapLoc;
        const collectionIdsSorted = Object.keys(collectionIdsMap).sort((a, b) => collectionIdsMap[b] - collectionIdsMap[a]);

        console.log('collectionIdsSorted');
        console.log(collectionIdsSorted);
        console.log(collectionIdsSortedMap);

        collectionIdsSorted.forEach((element) => {
            this.props.getPodcastData(parseInt(element));
        });
        this.setState({ collectionIdsSortedMap, collectionIdsSorted })
    }

    render() {
        const { insights, dbPodcastState } = this.props;
        if (!insights || Object.keys(insights).length < 1) {
            return (<EmptyState imageHeight='200px'
                message="Your Saved Insights will show up here." imageName="empty" />)
        }
        const { collectionIdsSorted, collectionIdsSortedMap } = this.state;
        return (
            <div>
                <div className='flex'>
                    {collectionIdsSorted.map((collectionId, ind) => (
                        <div key={ind} style={{ marginRight: `${spacing('xl')}`, marginBottom: '2em', cursor: 'pointer' }}>
                            {dbPodcastState[collectionId] && <AppCustomLink
                                as={`/insights/${collectionId}`}
                                href={`/insights/${collectionId}`}>
                                <a>
                                    {/* <Podcast podcast={dbPodcastState[collectionId] || {}}
                                        marginBottom={'1px'}
                                        showSubscribe={false} size='lg' /> */}
                                    <img src={bookImage(dbPodcastState[collectionId])} alt={`${dbPodcastState[collectionId].collectionName || ''} book`} />

                                    <h4 className='text-center'>
                                        {collectionIdsSortedMap[collectionId]} {singular('Insight', collectionIdsSortedMap[collectionId])}
                                    </h4>
                                </a>
                            </AppCustomLink>}
                        </div>
                    ))}
                </div>
                <style jsx>
                    {`
                    .flex {
                        display: flex;
                        flex-wrap: wrap;
                        // justify-content: space-between;
                    }

            img {
                width: 100%;
                // min-height: 120px; // so that images load better.
                width: 160px;
                min-width: ${minImageWidth};
                border-radius: ${spacing('md')};
                // box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
                box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
                margin-bottom: 8px;
              }
                        `}
                </style>
            </div>
        )
    }
}


InsightCards.propTypes = {
    insights: PropTypes.object,
    dbPodcastState: PropTypes.object,
    // guid: PropTypes.string,
    // collectionId: PropTypes.any,
    getPodcastData: PropTypes.func,
    // deleteInsights: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        insights: state.insights,
        dbPodcastState: state.dbPodcastState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getPodcastData: bindActionCreators(getPodcastData, dispatch),
        // deleteInsights: bindActionCreators(deleteInsights, dispatch),
        // setAllEpisodesAsPlayed: bindActionCreators(setAllEpisodesAsPlayed, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InsightCards);
